// extracted by mini-css-extract-plugin
module.exports = {"inspirationTileWrapper":"InspirationTile_inspirationTileWrapper__Ji2qo"};